import type { ReactNode } from 'react'

import { cn } from '@/lib/cn'

type Tone = 'gold' | 'muted' | 'ember'

const TONES: Record<Tone, string> = {
  gold: 'border-gold/40 text-gold',
  muted: 'border-line text-faint',
  ember: 'border-ember/50 text-ember',
}

export function Badge({
  children,
  tone = 'muted',
  className,
}: {
  children: ReactNode
  tone?: Tone
  className?: string
}) {
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full border px-2.5 py-0.5 text-[0.625rem] font-medium uppercase tracking-[0.16em]',
        TONES[tone],
        className,
      )}
    >
      {children}
    </span>
  )
}
